import React from 'react';
import * as css from './spacer.module.scss';
import classNames from 'classnames';

interface SpacerProps {
  width: number;
}

interface FlexSpacerProps extends SpacerProps {
  className?: string;
}

const Spacer: React.FC<React.PropsWithChildren<SpacerProps>> = ({ width }) => {
  return (
    <div style={{ width: `${width}px`, minHeight: '1px', float: 'left' }} />
  );
};

/* FlexSpacer is meant to wrap children. It will break otherwise. */
export const FlexSpacer: React.FC<React.PropsWithChildren<FlexSpacerProps>> = ({
  width,
  className,
  children,
}) => {
  if (!children) {
    console.error(
      'FlexSpacer is meant to wrap children. It will break otherwise.',
    );
  }

  return (
    <div className={classNames(css.spacer, className)}>
      <div style={{ width: `${width}em` }} />
      <div className={css.content}>{children}</div>
    </div>
  );
};

export default Spacer;
